<template>
  <div v-viewer="imageViewerConfig" v-show="false" id="viewer">
    <img v-for="image in images" :src="image.src" :key="image.src" :data-href="image.href" :alt="image.alt" />
  </div>
</template>

<script>
export default {
  name: "ImageViewer",
  props: {
    posts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      viewerOptions: {
        title(image) {
          return image.alt;
        }
      }
    };
  },
  computed: {
    images() {
      return this.posts.map(post => {
        return {
          src: post.images[1].imageUrl,
          href: post.images[0].imageUrl,
          alt: post.description
        };
      });
    },
    imageViewerConfig() {
      return {
        ...this.viewerOptions,
        ...this.$store.state.event.config.defaultLightBoxConfig
      };
    }
  }
};
</script>
